/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default [
    /*{
        url: "/",
        name: "Home",
        slug: "home",
        icon: "HomeIcon",
    },
    {
        url: "/page2",
        name: "Page 2",
        slug: "page2",
        icon: "FileIcon",
    },*/
    {
        url: "/user",
        name: "Dashboard",
        slug: "user",
        icon: "GridIcon",
    },
    /*{
        url: "/admin",
        name: "Admin View",
        slug: "admin",
        icon: "UserIcon",
    },*/
    {
        url: "/user/downline",
        name: "Referrals",
        slug: "descendant",
        icon: "UsersIcon",
    },
    {
        url: "/user/activity",
        name: "Activity",
        slug: "transactions",
        icon: "DollarSignIcon",
    },
    {
        url: "/user/mlm-bonus",
        name: "MLM bonus",
        slug: "tree",
        icon: "Share2Icon",
    },
    {
        url: "/user/withdrawal",
        name: "Withdrawal requests",
        slug: "withdrawal",
        icon: "EditIcon",
    }
]
